<template>
  <button class="burger" @click="$emit('click')">
    <span class="burger__line"></span>
    <span class="burger__line"></span>
    <span class="burger__line"></span>
  </button>
</template>

<script>
export default {
  name: "TheHeaderBurger"
};
</script>

<style lang="scss">
.burger {
  width: 30px;
  height: 30px;
  align-self: center;
  &__line {
    display: block;
    width: 100%;
    height: 3px;
    background-color: colors(palette-2);
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
}
</style>
